let Minutes = [
    { minutes: "00" },
    { minutes: "01" },
    { minutes: "02" },
    { minutes: "03" },
    { minutes: "04" },
    { minutes: "05" },
    { minutes: "06" },
    { minutes: "07" },
    { minutes: "08" },
    { minutes: "09" },
    { minutes: "10" },
    { minutes: "11" },
    { minutes: "12" },
    { minutes: "13" },
    { minutes: "14" },
    { minutes: "15" },
    { minutes: "16" },
    { minutes: "17" },
    { minutes: "18" },
    { minutes: "19" },
    { minutes: "20" },
    { minutes: "21" },
    { minutes: "22" },
    { minutes: "23" },
    { minutes: "24" },
    { minutes: "25" },
    { minutes: "26" },
    { minutes: "27" },
    { minutes: "28" },
    { minutes: "29" },
    { minutes: "30" },
    { minutes: "31" },
    { minutes: "32" },
    { minutes: "33" },
    { minutes: "34" },
    { minutes: "35" },
    { minutes: "36" },
    { minutes: "37" },
    { minutes: "38" },
    { minutes: "39" },
    { minutes: "40" },
    { minutes: "41" },
    { minutes: "42" },
    { minutes: "43" },
    { minutes: "44" },
    { minutes: "45" },
    { minutes: "46" },
    { minutes: "47" },
    { minutes: "48" },
    { minutes: "49" },
    { minutes: "50" },
    { minutes: "51" },
    { minutes: "52" },
    { minutes: "53" },
    { minutes: "54" },
    { minutes: "55" },
    { minutes: "56" },
    { minutes: "57" },
    { minutes: "58" },
    { minutes: "59" },
  ];
  export default Minutes;
  